// src/config.js
export const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAp8F9rBZwGockT0A3t9wQ
1aaEIJKlQ/EwqIo6UA+a71BCIjwRQuAZHdIlK7MG+4BgpnbLXRu1a/Jt/1nCvHoU
kpl//mbu7E9r2vDoLa+nluhSG/puoxy0NKpzw/QEpnN8jP8S8Na6nC679afUSGhi
lKM4aixZKovoIyCYovimf6VD0ODzijsd9ZAzIBcN/BT4531rrkwWw8Mqu4n8mQjo
duBtcIPVXczfkL/88VkKwjQ1q86CqZL1sI+o3mfhV5CQL+enXE87H8zQ5LmCNT8e
wO4hkhPGPILQQQZMxDw3wJi/BDyldop6V2DL++KNT/Cmhe+pkZIqqmMJB06IoaPM
NQIDAQAB
-----END PUBLIC KEY-----`;
